// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-accommodation-features .img img{height:21rem;border-radius:.5rem;object-fit:cover}@media (min-width:640px){.section-accommodation-features .img img{height:100%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
